(function(){
  'use strict';
  var attempts=0;
  function boot(){
    var S=window.PGUploadsV51;
    if(!S||!S.ready){ if(++attempts<120) setTimeout(boot,50); return; }
    if(S.atcFeedbackV52) return;
    S.atcFeedbackV52=true;

    var form=S.form;
    if(!form) return;
    var host=(form.closest&&form.closest('[data-product-form]'))||document;
    var product=S.product||decode(host.getAttribute&&host.getAttribute('data-product'))||{};
    var state={busy:false,proxy:null,original:'',successTimer:null,blocked:false};

    function decode(raw){
      if(!raw) return null;
      try{return JSON.parse(raw);}catch(e){}
      try{var t=document.createElement('textarea');t.innerHTML=raw;return JSON.parse(t.value);}catch(e2){return null;}
    }
    function proxy(){
      var b=host.querySelector('.pg-cfg-next--atc[data-cfg-next]');
      if(b&&state.proxy!==b){state.proxy=b;state.original=b.innerHTML;}
      return b;
    }
    function clearTimer(){if(state.successTimer){clearTimeout(state.successTimer);state.successTimer=null;}}
    function paint(label,success){
      var b=proxy(); if(!b) return;
      if(!state.original) state.original=b.innerHTML;
      b.innerHTML=success?'<span class="pg-v52-atc-check" aria-hidden="true">&#10003;</span><span>'+label+'</span>':'<span class="pg-v52-atc-spinner" aria-hidden="true"></span><span>'+label+'</span>';
    }
    function lock(label){
      var b=proxy(); if(!b) return;
      clearTimer(); state.busy=true;
      b.classList.add('pg-v52-atc-busy'); b.classList.remove('pg-v52-atc-done');
      b.setAttribute('aria-busy','true'); b.setAttribute('aria-disabled','true');
      paint(label||'ADDING TO CART...',false);
    }
    function applyBlocked(blocked){
      var b=proxy(); state.blocked=!!blocked;
      if(!b||state.busy) return;
      b.classList.toggle('pg-v52-variant-unavailable',state.blocked);
      if(state.blocked){b.setAttribute('aria-disabled','true');b.setAttribute('title','This option combination is unavailable. Please choose another option.');}
      else{b.removeAttribute('aria-disabled');if(b.getAttribute('title')==='This option combination is unavailable. Please choose another option.')b.removeAttribute('title');}
    }
    function restore(){
      var b=proxy(); clearTimer(); state.busy=false;
      if(!b) return;
      b.classList.remove('pg-v52-atc-busy','pg-v52-atc-done'); b.removeAttribute('aria-busy');
      if(state.original) b.innerHTML=state.original;
      syncGuard();
    }
    function done(){
      var b=proxy(); if(!b) return;
      clearTimer(); state.busy=true;
      b.classList.remove('pg-v52-atc-busy'); b.classList.add('pg-v52-atc-done');
      b.setAttribute('aria-busy','false'); b.setAttribute('aria-disabled','true');
      paint('ADDED TO CART',true); state.successTimer=setTimeout(restore,1800);
    }
    function cartAddUrl(url){
      if(!url) return false; var path='';
      try{path=new URL(url,location.origin).pathname;}catch(e){path=String(url);}
      return /\/cart\/add(?:\.js)?$/.test(path);
    }
    function selectedValues(){
      var count=(product.options&&product.options.length)||0;
      var selectors=form.querySelectorAll('.single-option-selector'), values=[];
      if(!count&&selectors.length) count=selectors.length;
      if(!count) return null;
      for(var i=0;i<count;i++){
        var sw=form.querySelector('.swatch[data-option-index="'+i+'"]');
        if(sw){var checked=sw.querySelector('input[type="radio"]:checked');if(!checked)return null;values.push(String(checked.value||''));}
        else if(selectors[i]&&selectors[i].value) values.push(String(selectors[i].value));
        else return null;
      }
      return values;
    }
    function variantOptions(v){
      if(Array.isArray(v.options)) return v.options.map(String);
      var a=[]; if(v.option1!=null)a.push(String(v.option1));if(v.option2!=null)a.push(String(v.option2));if(v.option3!=null)a.push(String(v.option3));return a;
    }
    function decision(){
      var values=selectedValues(), variants=product.variants||[];
      if(!values||!variants.length) return {known:false,available:true};
      for(var i=0;i<variants.length;i++){
        var opts=variantOptions(variants[i]);
        if(opts.length!==values.length) continue;
        var match=true;
        for(var j=0;j<values.length;j++){if(String(opts[j])!==String(values[j])){match=false;break;}}
        if(match) return {known:true,available:variants[i].available!==false};
      }
      return {known:true,available:false};
    }
    function syncGuard(){var d=decision();applyBlocked(d.known&&!d.available);return d;}
    function showUnavailable(){if(typeof S.setError==='function')S.setError('That option combination is unavailable. Please choose another option.');applyBlocked(true);}

    var originalStatus=S.setStatus;
    S.setStatus=function(value){
      var v=String(value||'');
      if(/^Uploading your photo/i.test(v)){var m=v.match(/(\d{1,3})%/);lock(m?('UPLOADING PHOTOS '+m[1]+'%'):'UPLOADING PHOTOS...');}
      else if(/Adding to cart/i.test(v)) lock('ADDING TO CART...');
      else if(/^Thanks\. Your photo(?:s)? (?:is|are) attached\./i.test(v)) done();
      return originalStatus.apply(this,arguments);
    };
    var originalError=S.setError;
    S.setError=function(value){var r=originalError.apply(this,arguments);if(String(value||'').trim())restore();return r;};

    document.addEventListener('click',function(event){
      var target=event.target;
      var b=target&&target.closest&&target.closest('.pg-cfg-next--atc[data-cfg-next]');
      if(!b||!host.contains(b)) return;
      if(state.busy&&event.isTrusted){event.preventDefault();event.stopImmediatePropagation();return;}
      var d=syncGuard();
      if(d.known&&!d.available){event.preventDefault();event.stopImmediatePropagation();showUnavailable();return;}
      if(!state.busy&&S.native&&S.choice==='Send photos later') lock('ADDING TO CART...');
    },true);

    form.addEventListener('submit',function(event){
      var d=syncGuard();
      if(d.known&&!d.available){event.preventDefault();showUnavailable();}
    },true);

    document.addEventListener('change',function(event){
      var t=event.target;
      if(!t||!form.contains(t)||!(t.matches&&((t.matches('.swatch input[type="radio"]'))||t.matches('.single-option-selector')))) return;
      if(state.busy) restore(); setTimeout(syncGuard,25);
    });

    var $=window.jQuery;
    if($&&$.fn&&typeof $.fn.on==='function'){
      $(document).on('ajaxSuccess.pgV52Atc',function(event,xhr,settings){if(state.busy&&S.choice==='Send photos later'&&cartAddUrl(settings&&settings.url))done();});
      $(document).on('ajaxError.pgV52Atc',function(event,xhr,settings){if(state.busy&&S.choice==='Send photos later'&&cartAddUrl(settings&&settings.url))restore();});
    }
    document.addEventListener('cart:refresh',function(){if(state.busy&&S.choice==='Send photos later')done();});
    window.addEventListener('pageshow',restore);
    setTimeout(syncGuard,80); setTimeout(syncGuard,500);

    var css=document.createElement('style');
    css.textContent='.pg-cfg-next--atc.pg-v52-atc-busy{pointer-events:none}.pg-v52-atc-spinner{display:inline-block;width:16px;height:16px;margin-right:9px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;vertical-align:-3px;animation:pgV52AtcSpin .7s linear infinite}.pg-cfg-next--atc.pg-v52-atc-done{pointer-events:none}.pg-cfg-next--atc.pg-v52-variant-unavailable{opacity:.55;cursor:not-allowed}@keyframes pgV52AtcSpin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.pg-v52-atc-spinner{animation:none;border-right-color:currentColor}}';
    document.head.appendChild(css);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
